import type { AppState } from '@protector/entities/__legacy__/redux.types';
import type { ActionsObservable, StateObservable } from 'redux-observable';
import { ofType } from 'redux-observable';
import { of } from 'rxjs/internal/observable/of';
import { catchError, concatMap, map, switchMap, withLatestFrom } from 'rxjs/operators';
import {
  LoadProductsByIdsSuccess,
  LoadProductsFailure,
  LoadProductsSuccess,
  ProductActionsTypes,
  type LoadProducts,
  type LoadProductsByIds
} from './product.actions';
import { getAllProductsWithMemoization, getProductsByIds } from './product.service';

export const handleLoadProducts = (action$: ActionsObservable<ReturnType<typeof LoadProducts>>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType(ProductActionsTypes.LOAD_PRODUCT),
    map(action => action.payload),
    withLatestFrom(state$.pipe(map(state => state.uiState.global.systemFlags))),
    switchMap(([payload, flags]) => {
      // Workaround - We reduce this value because we have a problem in pagination on Platform side
      // (Rollback to 6000 after Ticket CWS-19775 is resolved)
      return getAllProductsWithMemoization(payload.companyId, 3000, !!flags?.P40_38006_LOAD_PRODUCTS_PARALLEL).pipe(
        map(response => {
          return LoadProductsSuccess(response);
        }),
        catchError((error: string) => of(LoadProductsFailure(error)))
      );
    })
  );

export const handleLoadProductsByIds = (action$: ActionsObservable<ReturnType<typeof LoadProductsByIds>>) =>
  action$.pipe(
    ofType(ProductActionsTypes.LOAD_PRODUCT_BY_IDS),
    map(action => action.payload),
    concatMap(ids =>
      getProductsByIds(ids).pipe(
        map(products => {
          return LoadProductsByIdsSuccess(products);
        })
      )
    )
  );
